"use client";

import { useRef } from "react";

const LONG_PRESS_DELAY_MS = 1_500;

export function useLongPress(onLongPress: () => void) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const triggered = useRef(false);

  const start = () => {
    triggered.current = false;
    timer.current = setTimeout(() => {
      triggered.current = true;
      onLongPress();
    }, LONG_PRESS_DELAY_MS);
  };

  const clear = () => {
    if (timer.current) clearTimeout(timer.current);
  };

  // Suppress the click/navigation that follows a long-press release.
  const onClick = (e: React.MouseEvent) => {
    if (triggered.current) {
      e.preventDefault();
      triggered.current = false;
    }
  };

  return {
    onPointerDown: start,
    onPointerUp: clear,
    onPointerLeave: clear,
    onPointerCancel: clear,
    onClick,
  };
}
